import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const [password, setPassword] = useState<string>('');
  const { login, error } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    await login(password);
    setIsLoading(false);
  };

  return (
    <LoginWrapper>
      <LoginContainer>
        <LoginTitle>부부마을 심방 스케줄</LoginTitle>
        <LoginForm onSubmit={handleSubmit}>
          <LoginInput
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
            required
          />
          <LoginButton type="submit" disabled={isLoading}>
            {isLoading ? '로그인 중...' : '로그인'}
          </LoginButton>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
            ※동안교회 부부마을 목자님들만 이용하실 수 있습니다.
          </p>
        </LoginForm>
      </LoginContainer>
    </LoginWrapper>
  );
};

const LoginWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

const LoginContainer = styled.div`
  width: 400px;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  margin: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const LoginTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const LoginInput = styled.input`
  height: 50px;
  padding: 10px 15px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #3d85f5;
  }
`;

const LoginButton = styled.button`
  height: 50px;
  background-color: #3d85f5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2a6ddb;
  }

  &:disabled {
    background-color: #a0c0f0;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: #e30747;
  margin-top: 15px;
  text-align: center;
`;

export default Login;
